import {Component, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import {SitesService} from '../../../services/sites.service';
import {SiteIndexPageScoresTableRowModel} from '../../../models/SiteIndexPageScoresTableRowModel';
import { LocalDataSource } from 'ng2-smart-table';
import {PageSpeedScoreRenderComponent} from '../../../ng-smart-table-renderers/table-cell-renderers/page-speed-score-render.component';
import {SiteUrlCellRenderComponent} from './site-url-cell-render.component';
import {GetCustomerCategoryResponseDto} from '../../../models/GetCustomerCategoryResponseDto';

@Component({
    selector: 'app-sites-table',
    templateUrl: './sites-table.component.html',
    styleUrls: ['./sites-table.component.css'],
    encapsulation: ViewEncapsulation.None
})
export class SitesTableComponent implements OnInit, OnDestroy {

    searchQuery = '';
    chosenCustomerCategories = new Array<GetCustomerCategoryResponseDto>();

    settings = {
        attr: {
            'class': 'table table-striped site-review-scores-table'
        },
        pager: {
            perPage: 15
        },
        actions: false,
        columns: {
            customerName: {
                title: 'Customer',
                filter: false
            },
            siteUrl: {
                title: 'Website',
                filter: false,
                type: 'custom',
                renderComponent: SiteUrlCellRenderComponent
            },
            triggerCategoryName: {
                title: 'Website Category',
                filter: false
            },
            gpd: {
                title: 'GPD',
                filter: false,
                type: 'custom',
                renderComponent: PageSpeedScoreRenderComponent
            },
            gpm: {
                title: 'GPM',
                filter: false,
                type: 'custom',
                renderComponent: PageSpeedScoreRenderComponent
            },
            seoIndex: {
                title: 'No Index',
                filter: false
            },
            seoTitle: {
                title: 'Title',
                filter: false
            },
            seoFollow: {
                title: 'Follow',
                filter: false
            },
            seoDescription: {
                title: 'Desciption',
                filter: false
            }
        }
    };

    data: Array<SiteIndexPageScoresTableRowModel>;
    source: LocalDataSource;

    constructor(private sitesService: SitesService) {}

    ngOnInit(): void {
        this.sitesService.getOnSitesIndexPagesScoresLoadedSubject().subscribe(data => {
            this.data = data;
            this.source = new LocalDataSource(this.data);
        });
    }

    onCustomerCategoryChanged(customerCategories: Array<GetCustomerCategoryResponseDto>) {
        this.restoreTableData();
        this.chosenCustomerCategories = customerCategories;

        if (this.chosenCustomerCategories.length) {
            if (this.searchQuery.length) {
                this.searchByQueryString(this.searchByCustomerCategories);
            } else {
                this.searchByCustomerCategories();
            }
        } else {
            if (this.searchQuery.length) {
                this.searchByQueryString();
            }
        }
        this.restoreTableData();
    }

    onSearch(search: string) {
        this.restoreTableData();
        this.searchQuery = search;

        if (this.searchQuery.length > 0) {
            if (this.chosenCustomerCategories.length > 0) {
                this.searchByCustomerCategories(this.searchByQueryString);
            } else {
                this.searchByQueryString();
            }
        } else {
            if (this.chosenCustomerCategories.length > 0) {
                this.searchByCustomerCategories();
            }
        }
    }

    private searchByCustomerCategories(callback: Function = null) {
        this.source.setFilter([this.createCustomerCategoryFilter()], false).getFilteredAndSorted().then(
            (data) => {
                this.setTableData(data);
                if (callback != null) {
                    callback.call(this);
                }
            }
        );
    }

    private searchByQueryString(callback: Function = null) {
        this.source.setFilter(this.createSearchQueryFilter(this.searchQuery), false).getFilteredAndSorted().then(
            (data) => {
                this.setTableData(data);
                if (callback != null) {
                    callback.call(this);
                }
            }
        );
    }

    private setTableData(data: Array<GetCustomerCategoryResponseDto>) {
        this.source = new LocalDataSource(data);
    }

    private restoreTableData() {
        this.source = new LocalDataSource(this.data);
        this.source.setFilter([]);
    }

    private createCustomerCategoryFilter(): {field: string, search: string, filter: Function} {
        return {
            field: 'customerCategoryName',
            search: this.chosenCustomerCategories.map((category) => category.name).join(' '),
            filter: (cellValue: string, categoryNames: string) => {
                return categoryNames.indexOf(cellValue) > -1;
            }
        };
    }

    private createSearchQueryFilter(searchQuery: string): Array<{field: string, search: string}> {
        return [
            {
                field: 'customerName',
                search: searchQuery
            },
            {
                field: 'siteUrl',
                search: searchQuery
            },
            {
                field: 'triggerCategoryName',
                search: searchQuery
            }
        ];

    }

    ngOnDestroy(): void {}
}



// WEBPACK FOOTER //
// C:/Visual Studio Projects/Novicell Performance Platform/PerformancePlatform/Novicell.Performance.Website/ui/src/app/components/sites/sites-table/sites-table.component.ts